/* eslint import/prefer-default-export: 0 */
import * as t from './action_types';

const initialState = {
  taskOffersFetching: false,
  taskUpdate: {
    error: null,
    isFetching: false,
    status: null,
    taskId: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case t.SET_TASK_UPDATE_FETCHING_FLAG:
      return {
        ...state,
        taskUpdate: {
          ...state.taskUpdate,
          isFetching: action.payload.isFetching,
        },
      };
    case t.SET_TASK_UPDATE_STATUS:
      return {
        ...state,
        taskUpdate: {
          ...state.taskUpdate,
          status: action.payload.status,
        },
      };
    case t.SET_TASK_UPDATE_ERROR:
      return {
        ...state,
        taskUpdate: {
          ...state.taskUpdate,
          error: action.payload.error,
        },
      };
    case t.SET_LAST_TASK_ID:
      return {
        ...state,
        taskUpdate: {
          ...state.taskUpdate,
          taskId: action.payload.taskId,
        },
      };
    case t.SET_TASK_OFFERS_FETCHING_FLAG:
      return {
        ...state,
        taskOffersFetching: action.payload.isFetching,
      };
    default:
      return state;
  }
};
